<template>
    <base-modal :value="value" @input="close"
        :modal-classes="modalClasses"
        :modal-content-classes="modalContentClasses"
        backdrop="static"
    >
        <div class="py-3 text-center" v-if="status == 'prompted'">
            <h3 class="heading mt-4">{{ $t('pwa.sync-modal-title') }}</h3>
            <p>{{ $t('pwa.sync-modal-description') }}</p>
        </div>

        <div class="started py-3 text-center" v-if="status == 'started'">
            <h3 class="heading mt-4">{{ $t('pwa.sync-modal-title') }}</h3>
            <p>{{ $t('pwa.sync-modal-progress') }}</p>

            <base-progress show-label type="white" :height="8" class="mb-4"
                :value="progress"
                 v-if="progressTotal">
            </base-progress>
        </div>

        <div class="py-3 text-center" v-if="status == 'done'">
            <i class="tim-icons icon-check-single icon-3x"></i>
            <h3 class="heading mt-4">{{ $t('pwa.sync-modal-done') }}</h3>
            <p>{{ $t('pwa.sync-modal-done-description') }}</p>
        </div>

        <div class="py-3 text-center" v-if="status == 'error'">
            <i class="tim-icons icon-t-warning icon-3x"></i>
            <h3 class="heading mt-4">{{ $t('pwa.sync-modal-error') }}</h3>
            <p>{{ errorMessage }}</p>
        </div>

        <template slot="footer">
            <div class="text-center" v-if="status == 'prompted'">
                <base-button type="white" @click="start">{{ $t('common.start') }}</base-button>
                <base-button type="link" class="text-white" @click="close">{{ $t('common.cancel') }}</base-button>
            </div>
            <div class="text-center" v-if="status == 'error'">
                <base-button type="link" class="text-white" @click="close">{{ $t('common.close') }}</base-button>
            </div>
            <div class="text-center" v-if="status == 'done'">
                <base-button type="white" @click="remove">{{ $t('pwa.remove') }}</base-button>
                <br>
                <base-button type="link" class="text-white" @click="close">{{ $t('pwa.not-now') }}</base-button>
            </div>
        </template>
    </base-modal>
</template>

<script>
    export default {
        
        props: {

            value: {
                type: Object,
                required: true
            },

            sync: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                status: null,       // Modal status: prompted, started, done
                syncData: {
                    status: null    // Sync status returned by the SW
                },
                errorMessage: null
            }
        },

        watch: {
            value(val) {
                if (val.show) {
                    this.status = 'prompted'
                    this.syncData = {
                        status: null    // Reinit sync data (important)
                    }
                }
            }
        },

        computed: {

            modalClasses() {
                if (this.status == 'error') {
                    return 'modal-danger'
                }
                if (this.status == 'done') {
                    return 'modal-success'
                }
                return 'modal-info'
            },
            
            modalContentClasses() {
                if (this.status == 'error') {
                    return 'bg-gradient-danger'
                }
                if (this.status == 'done') {
                    return 'bg-gradient-success'
                }
                return 'bg-gradient-info'
            },

            progressCount() {
                let count = 0
                if (this.syncData.feedbacks) {
                    count += this.syncData.feedbacks.synced
                }
                if (this.syncData.issues) {
                    count += this.syncData.issues.synced
                }
                return count
            },

            progressTotal() {
                let count = 0
                if (this.syncData.feedbacks) {
                    count += this.syncData.feedbacks.total
                }
                if (this.syncData.issues) {
                    count += this.syncData.issues.total
                }
                return count
            },

            progress() {
                if (!this.progressTotal) {
                    return 0
                } else {
                    return parseInt(this.progressCount * 100 / this.progressTotal)
                }
            }
        },

        methods: {

            start() {
                this.status = 'started'
                this.continue()
            },

            continue() {
                if (this.syncData.status == 'done') {
                    // Sync is finished.
                    this.status = 'done'
                    this.$emit('done')
                } else {
                    // Next step.
                    axios.put(this.sync.endpoint, this.sync.params)
                    .then(resp => {
                        this.syncData = resp.data.data.sync
                        this.sync.params.force = false  // We must deactivate force option for subsequents requests.
                        this.continue()
                    }).catch(error => {
                        this.handleError(error)
                    })
                }
            },

            remove() {
                axios.delete(this.sync.endpoint, { data: this.sync.params})
                .then(resp => {
                    this.$emit('done')
                    this.close()
                }).catch(this.handleError)
            },

            handleError(error) {
                if (!error.response) {
                    return
                }
                this.status = 'error'
                switch(error.response.status) {
                    case 403:
                    case 404:
                    case 405:
                    case 444:
                        this.errorMessage = this.$t('pwa.http-error-' + error.response.status)
                        break
                    default:
                        this.$auth.handleErrorVm(error, this)
                }
            },

            close() {
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                })
            }
        }
    }
</script>

<style scoped>

    .started >>> .progress-percentage span {
        color: #eee;
    }
    .started >>> .progress {
        background-color: rgba(255, 255, 255, .5);
    }
    .started >>> .progress-label {
        display: none;
    }

</style>